import React from "react";
import styled from "styled-components";

const InfoStrip = () => (
  <Strip>
    <Cell>
      <b>Novi drop</b> — dostupno odmah
    </Cell>
    <Cell>
      Besplatna dostava <b>7.000+ RSD</b>
    </Cell>
    <Cell>
      Lično preuzimanje — <b>Novi Sad</b>
    </Cell>
    <Cell>
      <span className="kj">改善</span> Kaizen — 1% bolje svaki dan
    </Cell>
  </Strip>
);

export default InfoStrip;

const Strip = styled.section`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid var(--line, rgba(255, 255, 255, 0.07));
  background: var(--bg1, #101013);
`;

const Cell = styled.div`
  flex: 1 1 24%;
  padding: 1.8rem 1.6rem;
  font-size: 1.1rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--muted, #8e8c94);
  font-family: "Poppins-Medium";
  white-space: nowrap;
  text-align: center;

  & + & {
    border-left: 1px solid var(--line, rgba(255, 255, 255, 0.07));
  }

  b {
    color: var(--text, #f4f2ee);
    font-family: "Poppins-SemiBold";
    font-weight: 600;
  }

  .kj {
    font-family: var(--font-kanji);
    color: var(--red, #fe5f55);
  }

  @media (max-width: 900px) {
    flex: 1 1 50%;

    &:nth-child(3) {
      border-left: none;
    }

    &:nth-child(n + 3) {
      border-top: 1px solid var(--line, rgba(255, 255, 255, 0.07));
    }
  }

  /* Telefon: samo dostava + preuzimanje, u jednom redu */
  @media (max-width: 640px) {
    white-space: normal;
    font-size: 1rem;
    letter-spacing: 0.1em;
    padding: 1.3rem 1rem;

    &:nth-child(1),
    &:nth-child(4) {
      display: none;
    }

    &:nth-child(2) {
      border-left: none;
    }

    &:nth-child(3) {
      border-top: none;
      border-left: 1px solid var(--line, rgba(255, 255, 255, 0.07));
    }
  }
`;
